export default __webpack_public_path__ + "static/media/gallery-wip-emitter_16.9373ca36.jpg";